// Coarse device classification sent with each pageview. Two buckets only —
// tablets count as mobile. Best-effort: UA hints where available, otherwise
// user-agent sniffing.
export function getDeviceType() {
  try {
    const uaData = navigator.userAgentData;
    if (uaData && typeof uaData.mobile === "boolean") {
      return uaData.mobile ? "mobile" : "desktop";
    }
    const ua = navigator.userAgent || "";
    if (/Mobi|Android|iPhone|iPod|iPad/i.test(ua)) return "mobile";
    // iPadOS Safari reports itself as macOS; multi-touch gives it away.
    if (/Mac/.test(ua) && navigator.maxTouchPoints > 1) return "mobile";
    return "desktop";
  } catch (_err) {
    return "desktop";
  }
}
